import api from "../axiosIntercepture";

/** Set in `.env` as `REACT_APP_APPOINTMENT_WAREHOUSE` if the UI does not collect warehouse. */
function warehouseForCreateHeader(header = {}) {
    const fromEnv = process.env.REACT_APP_APPOINTMENT_WAREHOUSE?.trim();
    if (!fromEnv) return header;
    return { ...header, Warehouse: fromEnv };
}

export const fetchAppointments = async (page = 0, pageSize = 10) => {
    try {
        const response = await api.post(
            "/appointment/fetch-multi-dynamic",
            { page, limit: pageSize }
        );
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message || "Failed to fetch appointments";
    }
};

export const fetchAppointmentById = async (appointmentId) => {
    try {
        const response = await api.post(
            `/appointment/fetch-multi-dynamic?id=${appointmentId}`,
            {}
        );
        return response.data?.data?.data?.[0] || null;
    } catch (err) {
        throw err?.response?.data?.message || "Failed to fetch appointment";
    }
};

export const createAppointment = async (payload) => {
    try {
        const body = {
            ...payload,
            ...(payload?.AppointmentHeader && {
                AppointmentHeader: warehouseForCreateHeader(payload.AppointmentHeader),
            }),
        };
        const response = await api.post("/appointment/create", body);
        if (response.data?.success === false) {
            const message =
                response.data?.message || "Failed to create appointment";
            throw new Error(message);
        }
        return response.data?.data ?? response.data;
    } catch (err) {
        const message =
            err?.response?.data?.message ||
            err?.message ||
            "Failed to create appointment";
        throw typeof message === "string" ? new Error(message) : err;
    }
};

/** sessionStorage: preset when opening Create Appointment from ASN list (Inbound + ASN `sourceKeys`). */
export const APPOINTMENT_CREATE_PRESET_STORAGE_KEY =
    "partner-portal:appointment-create-preset";
